import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { SharedService } from "../../services/core/shared.service";
import { MatDialog } from "@angular/material/dialog";
import { AuthService } from "@shared/auth/auth.service";


@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent {

  defaultRoute: string = 'login';
  homeRoute: string = 'lab-user-menu';
  route: string = 'route';
  redirectFromProfile: string = 'redirectFromProfile';
  loggingIn: boolean = false;

  constructor(
    private router: Router,
    public sharedService: SharedService,
    private authService: AuthService,
    public dialog: MatDialog
  ) { }

  ngOnInit(): void {
    // Check if user is already authenticated
    if (this.authService.isAuthenticated()) {
      this.loggingIn = true;
      this.authService.loadUserInformation();
      this.router.navigateByUrl(this.homeRoute);
    } else {
      // console.log('User is NOT authenticated');
      // Authentication state changes are now handled in app.component.ts
      // This component only shows the login UI when user is not authenticated
    }
  }

  login(): void{
    window.localStorage.setItem(this.redirectFromProfile, 'true');
    this.authService.login();
  }

  loginRedirect(redirect: string): void {
    if (redirect == 'cancel' || redirect == null || redirect == '') {
      return;
    }
    window.localStorage.setItem(this.route, redirect);
    this.authService.login();
  }

}
